/**
 * IdlePresenceScreen — Between sessions: wall clock, breath dot, the system is here.
 *
 * M3-UX-P1-002: Shown during non-meditation containers (sleep, rest, meal breaks).
 * Replaces the countdown dial when no practitioner attention is needed.
 * UI-INV-005: Leaf component, props only, no engine imports.
 *
 * Sensory: { sight: wall-clock + breath-dot, sound: none, touch: none, silence: default }
 *
 * Design: sensory-screens.jsx IdlePresenceScreen
 */
import { useState, useEffect } from "react";
import styles from "./IdlePresenceScreen.module.css";
import { TIMING } from "../constants";

type Props = {
  retreatName: string;
  nextBellLabel: string;
  nextSessionName: string;
};

function currentTimeLabel(): string {
  return new Date().toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

export function IdlePresenceScreen({
  retreatName,
  nextBellLabel,
  nextSessionName,
}: Props) {
  const [clock, setClock] = useState(currentTimeLabel);

  useEffect(() => {
    const id = setInterval(() => setClock(currentTimeLabel()), TIMING.IDLE_CLOCK_UPDATE_MS);
    return () => clearInterval(id);
  }, []);

  return (
    <div className={styles.idle}>
      <div className={styles.retreatLabel}>{retreatName} · in progress</div>

      <div className={styles.clock} aria-label={`Current time: ${clock}`}>
        {clock}
      </div>

      <div className={styles.breathDot} aria-hidden="true" />

      <div className={styles.message}>
        Between sessions. The system is here.
      </div>

      <div className={styles.nextBell}>
        Next bell · {nextBellLabel} · {nextSessionName}
      </div>
    </div>
  );
}
